import { RemoteGetAllProfessionalsNotPaginated } from 'data/usecases/professionals';
import { GetAllProfessionalsNotPaginatedUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionals } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllProfessionalsNotPaginated =
  (): GetAllProfessionalsNotPaginatedUseCaseInterface =>
    new RemoteGetAllProfessionalsNotPaginated(
      makeApiUrlProfessionals(),
      makeAxiosHttpClient(),
    );
